import { CognitoGroups, CognitoUser } from "../../models/CognitoUser";

type Result = {
  operation: "and" | "or";
};

export class RoleService {
  private roles?: CognitoGroups[];
  private user?: CognitoUser;

  /**
   * Set the roles to be used for authorization
   * @param roles
   */
  public hasRoles(roles?: CognitoGroups[], user?: CognitoUser) {
    this.roles = roles;
    this.user = user;
    return this;
  }

  /**
   * Allows authorization only if all the role requirements are met
   */
  public all() {
    if (this.noRolesRequired()) return true;
    const groups = this.filterAutoGeneratedGroups();
    if (!groups) return false;
    // Ensure that the cognito groups array and roles array match
    return (
      groups.length === this.roles?.length && // Don't forget length, this can return true when it shouldn't if not included
      groups.every((el) => this.roles?.includes(el))
    );
  }

  /**
   * Allows authorization if at least one of the role requirements are met
   */
  public oneOf() {
    if (this.noRolesRequired()) return true;
    const groups = this.filterAutoGeneratedGroups();
    if (!groups) return false;
    const result = this.roles?.find((role) => {
      if (groups.includes(role)) return role;
    });
    return !!result;
  }

  /**
   * Filters out auto generated groups as these are not used for authorization
   */
  private filterAutoGeneratedGroups = () => {
    const groups = this.user?.signInUserSession?.idToken.payload[
      "cognito:groups"
    ];
    if (!groups) return undefined;
    return groups.filter((group) => !group?.startsWith("ag"));
  };

  /**
   * Check if roles exist
   */
  private noRolesRequired = () => {
    return !this.roles || !this.roles.length;
  };
}
